import {
  DASHBOARD_REQUEST,
  DASHBOARD_SUCCESS,
  DASHBOARD_FAIL,
} from "../actionTypes";
import {
  STATE_CITY_REQUEST,
  STATE_CITY_SUCCESS,
  STATE_CITY_FAIL,
} from "../actionTypes";

const initialState = {
  loading: false,
  userInfo: null,
  error: null,
};

// const dashboardReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case DASHBOARD_REQUEST:
//       return { ...state, loading: true };
//     case DASHBOARD_SUCCESS:
//       return { ...state, loading: false, userInfo: action.payload.data };
//     case DASHBOARD_FAIL:
//       return { ...state, loading: false, error: action.payload };
//     default:
//       return state;
//   }
// };
const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD_REQUEST:
      return { ...state, loading: true };
    case DASHBOARD_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case DASHBOARD_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};


export default dashboardReducer;
